import styled from "styled-components";
import colorsTheme from "@style/colors";

export const ModalOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.45);
	backdrop-filter: blur(2px);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 9999;
`;

export const BoxModal = styled.div`
	width: 420px;
	background-color: ${colorsTheme.white};
	border-radius: 8px;
	padding: 20px;
	box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.25);
`;

export const TitleModal = styled.h3`
	font-weight: bold;
	color: #000;
	font-size: 1rem;
	text-align: center;
	margin-bottom: 20px;
`;

export const ContainerInput = styled.div`
	margin-bottom: 20px;
`;

export const ErrorLabel = styled.p`
	color: #e53935;
	font-size: 13px;
	margin: 0 0 5px 4px;
`;

export const InputText = styled.input`
	width: 100%;
	border: 1px solid #c9c9c9;
	border-radius: 6px;
	padding: 10px 12px;
	font-size: 14px;

	&::placeholder {
		color: #757575;
	}

	&:focus {
		outline: none;
		border-color: #3f51b5;
	}
`;

export const InputWrapper = styled.div`
	position: relative;
	width: 100%;

	.required {
		position: absolute;
		right: 12px;
		top: 50%;
		transform: translateY(-50%);
		color: #e53935;
		font-size: 16px;
		pointer-events: none;
		transition: opacity 0.2s;
	}

	input:not(:placeholder-shown) ~ .required {
		opacity: 0;
	}
`;

export const ButtonsArea = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 10px;
	gap: 1rem;
`;

export const MessageText = styled.p`
	font-size: 15px;
	line-height: 1.4;
	color: #000;
	text-align: left;
	margin: 0 0 25px 0;

	b {
		font-weight: bold;
	}
`;
